export const isCoach = (roles: string[]) => roles.includes('coach');
